/**
 * NAD3-120 Live Orders Popup - JavaScript
 */

// Array of sample orders for NAD3-120
const orders = [
    { name: "Tricia", location: "NY", product: "NAD3 120 - 1 Bottle", time: "Just now" },
    { name: "Nickolas", location: "CO", product: "NAD3 120 - 1 Bottle", time: "2 minutes ago" },
    { name: "Jennifer", location: "OK", product: "NAD3 120 - 1 Bottle", time: "5 minutes ago" },
    { name: "Randy", location: "OK", product: "NAD3 120 - 1 Bottle", time: "8 minutes ago" },
    { name: "Faith", location: "MO", product: "NAD3 120 - 1 Bottle", time: "10 minutes ago" },
    { name: "Al", location: "NJ", product: "NAD3 120 - 1 Bottle", time: "12 minutes ago" },
    { name: "Mike", location: "AZ", product: "NAD3 120 - 3 Bottles", time: "15 minutes ago" },
    { name: "Frederick", location: "CA", product: "NAD3 120 - 3 Bottles", time: "18 minutes ago" },
    { name: "Desmond", location: "NY", product: "NAD3 120 - 1 Bottle", time: "20 minutes ago" },
    { name: "Michael", location: "TX", product: "NAD3 120 - 1 Bottle", time: "25 minutes ago" },
    { name: "Strange", location: "PA", product: "NAD3 120 - 1 Bottle", time: "30 minutes ago" },
    { name: "Michelle", location: "WA", product: "NAD3 120 - 1 Bottle", time: "35 minutes ago" },
    { name: "Eli", location: "GA", product: "NAD3 120 - 1 Bottle", time: "40 minutes ago" },
    { name: "Ricardo", location: "NM", product: "NAD3 120 - 1 Bottle", time: "45 minutes ago" },
    { name: "Rustin", location: "LA", product: "NAD3 120 - 1 Bottle", time: "50 minutes ago" },
    { name: "Aistis", location: "Lithuania", product: "NAD3 120 - 1 Bottle", time: "Just now" },
    { name: "Jeffrey", location: "TX", product: "NAD3 120 - 1 Bottle", time: "2 minutes ago" },
    { name: "Mark", location: "GA", product: "NAD3 120 - 3 Bottles", time: "5 minutes ago" },
    { name: "Steve", location: "MA", product: "NAD3 120 - 1 Bottle", time: "8 minutes ago" },
    { name: "Thomas", location: "SC", product: "NAD3 120 - 1 Bottle", time: "10 minutes ago" },
    { name: "Zoila", location: "MD", product: "NAD3 120 - 1 Bottle", time: "12 minutes ago" },
    { name: "Walter", location: "OH", product: "NAD3 120 - 1 Bottle", time: "15 minutes ago" },
    { name: "Morgan", location: "IL", product: "NAD3 120 - 3 Bottles", time: "18 minutes ago" },
    { name: "Calvin", location: "GA", product: "NAD3 120 - 1 Bottle", time: "20 minutes ago" },
    { name: "Christopher", location: "PA", product: "NAD3 120 - 1 Bottle", time: "25 minutes ago" },
    { name: "Roger", location: "CA", product: "NAD3 120 - 1 Bottle", time: "30 minutes ago" },
    { name: "Frank", location: "OH", product: "NAD3 120 - 1 Bottles", time: "35 minutes ago" },
    { name: "Jimmy", location: "OR", product: "NAD3 120 - 3 Bottles", time: "40 minutes ago" },
    { name: "Dina", location: "TX", product: "NAD3 120 - 1 Bottle", time: "45 minutes ago" },
    { name: "Raphael", location: "CA", product: "NAD3 120 - 1 Bottle", time: "50 minutes ago" },
    { name: "Nora", location: "CA", product: "NAD3 120 - 1 Bottle", time: "45 minutes ago" },
    { name: "Manuel", location: "NJ", product: "NAD3 120 - 1 Bottle", time: "50 minutes ago" }
];

// Display popup function
function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    
    popup.innerHTML = `
        <div class="popup-content">
            <div class="popup-image">
                <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon_NAD3_120ct_Page01.jpg?v=1733346589" alt="Product Image">
                <span class="glow-dot"></span>
            </div>
            <div class="popup-text">
                <div class="popup-line">
                    <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
                </div>
                <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
                <div class="popup-line order-time">${randomOrder.time}</div>
                <div class="verified-buyer-badge">Verified Buyer</div>
            </div>
        </div>
    `;
    
    popup.style.display = 'block';

    setTimeout(() => {
        popup.classList.add('popup-hide');
    }, 6000);

    setTimeout(() => {
        popup.style.display = 'none';
        popup.classList.remove('popup-hide');
        setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
}

// Random time intervals between popups
function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
}

// Start the popup display
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
});
